import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const upcomingViewState = (state: RootState) => state.scene.route.upcomingView;

export const isUpcomingViewInitializing = createSelector(
  upcomingViewState,
  ({ initializing }) => initializing
);

export const isUpcomingViewLoading = createSelector(upcomingViewState, ({ loading }) => loading);

export const getUpcomingViewState = createSelector(upcomingViewState, ({ viewState }) => viewState);

export const getUpcomingRoutes = createSelector(upcomingViewState, ({ routes }) => routes);

export const getUpcomingViewTotalFilteredRecordsCount = createSelector(
  upcomingViewState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getUpcomingViewTotalRecordsCount = createSelector(
  upcomingViewState,
  ({ totalRecords }) => totalRecords
);
